<template>
  <modal :center="false" :show="visible" modalClasses="modal-xxl">
    <b-row class="sticky-top pt-2 bg-light mt--3 mb-2">
      <b-col sm="12" md="4">
        <b-button class="mb-2" block variant="secondary" @click="handleClose">
          Đóng (Esc)
        </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <b-button block variant="info" @click="doPrint"> <i class="fa fa-print" aria-hidden="true"></i> In </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <b-button v-if="showPrice" block variant="success" @click="showPrice = !showPrice">
          <i class="fa fa-eye-slash" aria-hidden="true"></i>
          Ẩn giá
        </b-button>
        <b-button v-else block variant="success" @click="showPrice = !showPrice">
          <i class="fa fa-eye" aria-hidden="true"></i>
          Hiển thị giá
        </b-button>
      </b-col>
    </b-row>
    <block ref="bmdal" :nobody="true">
      <div id="print" class="print-box print-box-hz mt-3 mb-3">
        <div class="header text-center">
          <h3>CÔNG TY TNHH ĐAI MI VN</h3>
          ADD : 66/2 Đường LK 2-5, P.Bình Trị Đông, TP.HCM <br />
          Tel: 028-66828806 Email: daimivn@gmail.com <br />
          <hr style="margin-top:10px; margin-bottom:20px" />
          <h3>ĐƠN HÀNG : #{{ order.code }}</h3>
        </div>
        <br />
        <div class="info">
          <table class="prtable prtable-bordered">
            <tr>
              <th style="text-align: left;">Thông tin đặt hàng</th>
              <th>Thông tin giao hàng</th>
            </tr>
            <tr>
              <td style="text-align: left;">
                <span v-if="order.customer.short_name"> Tên: {{ order.customer.short_name }} </span>
                <span v-else>Tên: {{ order.customer.name }}</span> <br />
                <span>Mã KH : {{ order.customer.code }}</span>
                <!-- <span>MST : {{ order.customer.taxCode }}</span> <br /> -->
                <!-- <span>Email : {{ order.customer.email }}</span> <br /> -->
                <!-- <span>Người liên hệ : {{ order.customerContact.name }}</span> -->
                <!-- <br />
                <span>Chức vụ: {{ order.customerContact.position }}</span>
                <br />
                <span>SĐT liên hệ: {{ order.customerContact.phone }}</span>
                <br /> -->
              </td>
              <td style="text-align: left;">
                <span>Tên: {{ order.receiver.name }}</span> <br />
                <span>Địa chỉ nhận: {{ order.receiverContact.address }}</span>
                <!-- <span>MST: {{ order.receiver.taxCode }}</span> <br />
                <span>Email: {{ order.receiver.email }}</span> <br />
                <span>Người liên hệ:{{ order.receiverContact.name }}</span>
                <br />
                <span>Chức vụ: {{ order.receiverContact.position }}</span>
                <br />
                <span>SĐT liên hệ: {{ order.receiverContact.phone }}</span>
                <br /> -->
              </td>
            </tr>
          </table>

          <table class="prtable prtable-bordered" style="margin-top:20px">
            <tr>
              <th>STYLE NO</th>
              <th>Ngày đặt hàng</th>
              <th>Ngày giao hàng</th>
            </tr>
            <tr>
              <td>{{ order.poCode }}</td>
              <td>{{ $date(order.dateReceipt) }}</td>
              <td>{{ $date(order.dateDelivery) }}</td>
            </tr>
          </table>
        </div>
        <div class="data">
          <table class="prtable prtable-bordered">
            <thead>
              <tr>
                <th style="width:1px">STT.</th>
                <th style="width:1px">STYLE NO</th>
                <th style="width:1px">Quy cách</th>
                <th colspan="2" style="min-width:160px">Sản Phẩm</th>
                <th style="width:100px">Màu sắc</th>
                <th style="width:100px">Mã màu 1</th>
                <th style="width:100px">Mã màu 2</th>
                <th style="width:100px">Chiều dài</th>
                <th>Số lượng</th>
                <th>ĐVT</th>
                <th style="min-width:100px">Vị trí lưu kho</th>
                <th v-if="showPrice">Đơn giá</th>
                <th v-if="showPrice">Thành tiền</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in productOrders" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.poCode }}</td>
                <td>{{ item.productSpecify.name }}mm</td>
                <td v-if="!item.hiden" :rowspan="item.rowSpan">
                  {{ item.product.name }} <br />
                  <span v-if="item.reason">{{ item.reason.name }}</span>
                  <!-- {{ item.productCustom }} -->
                </td>
                <td v-if="!item.hiden" :rowspan="item.rowSpan">
                  {{ item.product.code }}
                </td>
                <td>
                  <span style="width: 30px; text-align: left;">
                    {{ capitalize(item.colorText) }}
                  </span>
                </td>
                <td style="width: 30px;text-align: center;">
                  <span>
                    {{ item.colorCode }}
                  </span>
                </td>
                <td style="width: 30px;text-align: center;">
                  {{ item.colorCode2 }}
                </td>
                <td>
                  <span v-if="item.length && item.length > 0">{{ item.length }} cm</span>
                </td>
                <td>{{ $formatNumber(item.quantity) }}</td>
                <td>
                  {{ item.unit }}
                </td>
                <td>
                  <span v-if="item.productInfo">{{ item.productInfo.position }}</span>
                </td>
                <td v-if="showPrice">
                  {{ item.price }} {{ item.currency }} /
                  {{ $ucWord(item.unit) }}
                </td>
                <td v-if="showPrice">
                  {{ $formatNumber(Number(item.price) * Number(item.quantity)) }}
                  {{ item.currency }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="footer">
          <table class="prtable">
            <tr>
              <td colspan="2">
                <div v-html="order.note"></div>
              </td>
            </tr>
            <tr>
              <td class="text-center" style="vertical-align: top; width:60%">
                <br />
              </td>
              <td class="text-center" style="vertical-align: top; text-align:right">
                <h5>Người phụ trách</h5>
                <br />
                <br />
                <br />
                <br />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <event @doCancel="handleClose"></event>
    </block>
  </modal>
</template>
<script>
import { capitalize } from '@/utils/string';
export default {
  props: {},
  data() {
    return {
      visible: false,
      showPrice: true,
      order: {
        id: '',
        customer: {},
        customerContact: {},
        receiver: {},
        receiverContact: {}
      },
      productOrders: {}
    };
  },
  methods: {
    setData(order, productOrders) {
      this.order = order;

      // productOrders.sort((a, b) => {
      //   if (a.product.name < b.product.name) {
      //     return -1;
      //   }
      //   if (a.product.name > b.product.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
      // productOrders.sort((a, b) => {
      //   if (a.spec.name > b.spec.name) {
      //     return -1;
      //   }
      //   if (a.spec.name < b.spec.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
      productOrders.sort((a, b) => {
        if (a.product.name < b.product.name) {
          return -1;
        }
        if (a.product.name > b.product.name) {
          return 1;
        } else {
          if (Number(a.productSpecify.name) > Number(b.productSpecify.name)) {
            return 1;
          }
          if (Number(a.productSpecify.name) < Number(b.productSpecify.name)) {
            return -1;
          }
          return 0;
        }
      });

      for (let i = 0; i < productOrders.length; i++) {
        let item = productOrders[i];
        item.rowSpan = this.checkSameRow(productOrders, i, (a, b) => {
          return a.productSpecify.name == b.productSpecify.name && a.product.code == b.product.code;
        });
      }
      console.log('xxxx', productOrders);
      this.productOrders = productOrders;
    },
    checkSameRow(datas, index, compareX, count = 1) {
      let nextIndex = index + 1;
      if (nextIndex >= datas.length) return 1;
      let item = datas[index];
      let nextItem = datas[nextIndex];
      if (compareX(item, nextItem)) {
        count++;
        nextItem.hiden = true;
        return 1 + this.checkSameRow(datas, nextIndex, compareX, count);
      }
      return 1;
    },
    handleClose() {
      this.visible = false;
    },
    doPrint() {
      this.$print('print');
    },
    doSave() {
      this.$refs.bmdal.block();
      this.$emit('doSave', () => {
        this.order.id = true;
        this.$refs.bmdal.unBlock();
      });
    },
    capitalize(s) {
      return capitalize(s);
    }
  }
};
</script>
